import React from "react";
import { FieldRenderProps } from "react-final-form";
import { ListInput } from "../components/Inputs/ListInput";
import { Type, Validator } from "./Type";
import Chip from "@material-ui/core/Chip";
import { TextFieldComponent } from "../index";

export const ListInputComponent = ({
  input,
  meta,
  ...rest
}: FieldRenderProps<any>) => {
  const restProps = rest as any;

  return <ListInput {...restProps} input={input} meta={meta} />;
};

export const ListPresentationComponent = ({
  input,
  meta,
  ...rest
}: FieldRenderProps<any>) => {
  let view: any = <></>;
  if (input.value instanceof Array && input.value.length > 0) {
    view = input.value.map((option: any, index: number) => (
      <Chip
        key={option + index}
        label={option}
        deleteIcon={<></>}
        size="small"
      />
    ));
  }
  return view;
};

export const ListInputField = (...validators: Validator[]) =>
  new Type({
    Component: ListInputComponent,
    PresentationComponent: ListPresentationComponent,
    validators
  });

export const MultiTagField = (...validators: Validator[]) =>
  new Type({
    Component: TextFieldComponent,
    PresentationComponent: ListPresentationComponent,
    validators
  });
